export default __webpack_public_path__ + "static/media/accommodation3.aed8b847.webp";